var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 434,
    viewBox: "0 0 1440 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1764_14255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 434V124.594H1427.69V133.909H1420.05V145.772H1419.9V133.909H1401.37V145.772H1395.42V151.713H1386.93V108.495H1365.7V143.242H1355.52V149.164H1349.57V138.144H1337.68V122.045H1329.2V91.5338H1307.96V116.966H1296.92V124.594H1285.9V107.633H1272.31V96.6127H1260.42V108.495H1251.07V123.751H1242.59V118.653H1234.41V68.6504H1224.23V55.1005H1182.62V16.9422H1174.14V26.2757H1149.5V50.0025H1115.54V128.408H1099.41V155.949H1090.08V147.478H1082.42V68.6504L1073.93 60.1793H1068.84V50.0025H1045.08V60.1793H1036.15V65.6798L1031.48 70.3369V107.633H1020.44V100.867H1011.96V77.5431H991.162L977.99 64.4148H973.747V84.7493H961.862V94.0828H941.491V126.281H916.013V118.653H905.818V61.0226H883.738V44.9236H877.805V66.9638H872.698V61.0226H853.594V96.191L844.685 105.103V87.2983H803.923V111.025H790.349V103.397H748.742V121.202H734.304V77.9839H713.069V112.731H702.893V118.653H696.941V107.633H685.056V91.5338H676.57V61.0226H655.334V86.455H652.09V6.78454H641.914V0H621.523V5.94127H607.949V61.8658H597.754V93.2396H589.958V88.1416L579.072 98.7209V52.5515H533.222V120.359H515.386V133.065H508.454V142.399H495.706V131.379H493.325V73.7292H482.285V66.1014H472.934V38.1391H438.97V125.284L435.418 128.83V138.144H426.24V116.123H416.89V92.3771H405.005V79.6705H388.032V43.2179H342.182V122.888H334.541V56.787H318.413V67.8071L306.528 79.6705V108.495H269.165V133.909H258.97V79.6705H247.93V14.9873H213.12L193.459 34.6127V110.182H177.466V80.5138H150.298V93.2396H136.704V110.182H123.11V55.9437H88.3008V89.8473L77.6832 100.427V142.399H67.9296V126.281H54.336V159.341H32.256V174.597H19.5264V144.085H0V434H1440Z",
    fill: "url(#paint0_linear_1764_14255)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1764_14255",
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EECFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1764_14255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 434,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.06153fb26ef0fa27331afd44cee70e59.svg";
export { ForwardRef as ReactComponent };